var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "order-box insicht insicht--fade-up insicht--fast" },
    [
      _c(
        "div",
        { staticClass: "order-box__wrapper" },
        [
          _vm.maintenanceMode
            ? [
                _c(
                  "div",
                  {
                    staticClass: "order-box__content",
                    class: {
                      "order-box__content--loading":
                        _vm.loading || _vm.locationsLoading || _vm.isLoading
                    }
                  },
                  [
                    _c("Loader", {
                      staticClass: "order-box__loader",
                      attrs: {
                        show:
                          (_vm.loading || _vm.locationsLoading) &&
                          !_vm.isLoading
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-box__content-wrapper order-box__content-wrapper--order",
                        class: {
                          "order-box__content-wrapper--loading":
                            _vm.loading || _vm.locationsLoading || _vm.isLoading
                        }
                      },
                      [
                        _c("h2", {
                          staticClass: "order-box__title",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.langValue("LANG_ORDER_BOX_TITLE") ||
                                (_vm.$te("orderbox.title." + _vm.themeName)
                                  ? _vm.$t("orderbox.title." + _vm.themeName)
                                  : _vm.$t("orderbox.title.default"))
                            )
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "order-box__input order-box__input--not-available"
                          },
                          [
                            _c("h3", {
                              staticClass: "order-box__input-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("orderbox.maintenance.title")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("p", {
                              staticClass: "order-box__input-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("orderbox.maintenance.text")
                                )
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("Button", {
                          attrs: {
                            level: "primary",
                            text: _vm.$t("orderbox.maintenance.reloadButton"),
                            type: "button"
                          },
                          on: { click: _vm.reloadWidget }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            : _vm.hasFeature("FEATURE_ORDERBOX_DELIVERY") ||
              _vm.hasFeature("FEATURE_ORDERBOX_TAKEAWAY") ||
              _vm.hasFeature("FEATURE_RESERVATION")
            ? [
                _c(
                  "div",
                  {
                    staticClass: "order-box__content",
                    class: {
                      "order-box__content--loading": _vm.loading
                    }
                  },
                  [
                    _c("Loader", {
                      staticClass: "order-box__loader",
                      attrs: {
                        show:
                          (_vm.loading || _vm.locationsLoading) &&
                          !_vm.isLoading
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-box__content-wrapper order-box__content-wrapper--order",
                        class: {
                          "order-box__content-wrapper--loading": _vm.loading
                        }
                      },
                      [
                        _vm.hasFeature("FEATURE_ORDERBOX_DELIVERY") ||
                        _vm.hasFeature("FEATURE_ORDERBOX_TAKEAWAY")
                          ? [
                              _vm.isLoggedIn
                                ? _c("h2", {
                                    directives: [
                                      {
                                        name: "sanitize",
                                        rawName: "v-sanitize",
                                        value: _vm.$t(
                                          "orderbox.titleLoggedIn",
                                          {
                                            name:
                                              _vm.accountUserDetail.firstName
                                          }
                                        ),
                                        expression:
                                          "$t('orderbox.titleLoggedIn', { name: accountUserDetail.firstName })"
                                      }
                                    ],
                                    staticClass: "order-box__title"
                                  })
                                : _c("h2", {
                                    staticClass: "order-box__title",
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.langValue("LANG_ORDER_BOX_TITLE") ||
                                          (_vm.$te(
                                            "orderbox.title." + _vm.themeName
                                          )
                                            ? _vm.$t(
                                                "orderbox.title." +
                                                  _vm.themeName
                                              )
                                            : _vm.$t("orderbox.title.default"))
                                      )
                                    }
                                  }),
                              _vm._v(" "),
                              _vm.hasFeature("FEATURE_ORDERBOX_LOGIN") &&
                              (_vm.hasFeature("FEATURE_ACCOUNT") ||
                                _vm.hasFeature("FEATURE_ACCOUNT_LOGGEDIN")) &&
                              !_vm.isLoggedIn
                                ? _c("i18n", {
                                    staticClass: "order-box__login",
                                    attrs: {
                                      path: "orderbox.login",
                                      tag: "div"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "login",
                                          fn: function() {
                                            return [
                                              _c("a", {
                                                staticClass:
                                                  "order-box__login-link",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "orderbox.loginLogin"
                                                    )
                                                  )
                                                },
                                                on: { click: _vm.openLogin }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        },
                                        {
                                          key: "register",
                                          fn: function() {
                                            return [
                                              _c("a", {
                                                staticClass:
                                                  "order-box__login-link",
                                                attrs: {
                                                  href: "javascript:void(0)"
                                                },
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "orderbox.loginRegister"
                                                    )
                                                  )
                                                },
                                                on: { click: _vm.openRegister }
                                              })
                                            ]
                                          },
                                          proxy: true
                                        }
                                      ],
                                      null,
                                      false,
                                      1712527811
                                    )
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasFeature("FEATURE_ORDERBOX_DELIVERY")
                                ? [
                                    (_vm.deliveryLocations.length ||
                                      (!_vm.deliveryLocations.length &&
                                        _vm.locationsLoading)) &&
                                    (!_vm.selectedShippingMethod ||
                                      _vm.selectedShippingMethod == "delivery")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "order-box__input order-box__input--zip"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "order-box__input-group"
                                              },
                                              [
                                                _c("FormInput", {
                                                  ref: "zipInput",
                                                  staticClass:
                                                    "order-box__input-element",
                                                  attrs: {
                                                    name: "order-box-zip",
                                                    placeholder: _vm.$t(
                                                      "orderbox.deliveryLabel"
                                                    ),
                                                    label: _vm.$t(
                                                      "orderbox.deliveryLabel"
                                                    ),
                                                    minlength: 4,
                                                    maxlength: 4,
                                                    inputmode: "decimal",
                                                    pattern: "[0-9]{4}",
                                                    required: true,
                                                    error: false,
                                                    disabled:
                                                      _vm.loading ||
                                                      _vm.isLoading ||
                                                      _vm.locationsLoading
                                                  },
                                                  on: {
                                                    keydown: _vm.onZipKeydown,
                                                    input: _vm.onZipInput
                                                  },
                                                  model: {
                                                    value: _vm.form.zip,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "zip",
                                                        _vm._n($$v)
                                                      )
                                                    },
                                                    expression: "form.zip"
                                                  }
                                                }),
                                                _vm._v(" "),
                                                !_vm.selectedShippingMethod
                                                  ? _c("Button", {
                                                      staticClass:
                                                        "order-box__input-button",
                                                      attrs: {
                                                        level: "primary",
                                                        type: "button",
                                                        text: _vm.$t(
                                                          "orderbox.deliveryButton"
                                                        ),
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.isLoading ||
                                                          _vm.locationsLoading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.onDelivery.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.zip
                                              ? _c("span", {
                                                  staticClass:
                                                    "order-box__input-error input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.errors.zip
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      : !_vm.deliveryLocations.length &&
                                        !_vm.locationsLoading
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "order-box__input order-box__input--not-available"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "order-box__input-title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "orderbox.deliveryTitle"
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              staticClass:
                                                "order-box__input-text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("orderbox.comingSoon")
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.hasFeature("FEATURE_ORDERBOX_TAKEAWAY")
                                ? [
                                    (_vm.takeawayLocations.length ||
                                      (!_vm.takeawayLocations.length &&
                                        _vm.locationsLoading)) &&
                                    (!_vm.selectedShippingMethod ||
                                      _vm.selectedShippingMethod == "takeaway")
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "order-box__input order-box__input--zip"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "order-box__input-group"
                                              },
                                              [
                                                _vm.takeawayRegions.length > 1
                                                  ? _c("FormInputSelect", {
                                                      ref: "locationSelect",
                                                      staticClass:
                                                        "order-box__input-element",
                                                      attrs: {
                                                        options:
                                                          _vm.takeawayRegionOptions,
                                                        label: _vm.$t(
                                                          "orderbox.takeawayRegionLabel"
                                                        ),
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.isLoading ||
                                                          _vm.locationsLoading
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onTakeawayRegionSelect
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .selectedRegionCode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "selectedRegionCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.selectedRegionCode"
                                                      }
                                                    })
                                                  : _c("FormInputSelect", {
                                                      ref: "locationSelect",
                                                      staticClass:
                                                        "order-box__input-element",
                                                      attrs: {
                                                        options:
                                                          _vm.takeawayLocationOptions,
                                                        label: _vm.$t(
                                                          "orderbox.takeawayLabel"
                                                        ),
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.isLoading ||
                                                          _vm.locationsLoading
                                                      },
                                                      on: {
                                                        input:
                                                          _vm.onTakeawayLocationSelect
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form
                                                            .selectedLocationCode,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "selectedLocationCode",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.selectedLocationCode"
                                                      }
                                                    }),
                                                _vm._v(" "),
                                                !_vm.selectedShippingMethod
                                                  ? _c("Button", {
                                                      staticClass:
                                                        "order-box__input-button",
                                                      attrs: {
                                                        level: "primary",
                                                        type: "button",
                                                        text: _vm.$t(
                                                          "orderbox.takeawayButton"
                                                        ),
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.isLoading ||
                                                          _vm.locationsLoading
                                                      },
                                                      on: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          $event.preventDefault()
                                                          return _vm.onTakeaway.apply(
                                                            null,
                                                            arguments
                                                          )
                                                        }
                                                      }
                                                    })
                                                  : _vm._e()
                                              ],
                                              1
                                            ),
                                            _vm._v(" "),
                                            _vm.errors.location
                                              ? _c("span", {
                                                  staticClass:
                                                    "order-box__input-error input-error",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.errors.location
                                                    )
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        )
                                      : !_vm.takeawayLocations.length &&
                                        !_vm.locationsLoading
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "order-box__input order-box__input--not-available"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "order-box__input-title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "orderbox.takeawayTitle"
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("p", {
                                              staticClass:
                                                "order-box__input-text",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t("orderbox.comingSoon")
                                                )
                                              }
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedShippingMethod &&
                              _vm.deliveryLocationMatches.length > 1 &&
                              !_vm.location
                                ? _c(
                                    "div",
                                    { staticClass: "order-box__locations" },
                                    [
                                      _c("Button", {
                                        staticClass:
                                          "order-box__locations-reset",
                                        attrs: {
                                          level: "tertiary",
                                          type: "button",
                                          text: _vm.$t("orderbox.changeType"),
                                          arrow: "",
                                          reverse: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onCancel.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("h3", {
                                        staticClass:
                                          "order-box__locations-title",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t(
                                              "orderbox.locations.deliveryTitle"
                                            )
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.deliveryLocationMatches,
                                        function(location) {
                                          return _c("OrderBoxLocation", {
                                            key: location.code,
                                            attrs: {
                                              location: _vm.formatLocation(
                                                location,
                                                _vm.selectedShippingMethod,
                                                null,
                                                _vm.form.zip
                                              ),
                                              "shipping-method":
                                                _vm.selectedShippingMethod
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onDeliveryLocationSelect(
                                                  $event,
                                                  location.code
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedShippingMethod &&
                              _vm.takeawayRegionLocations.length > 1 &&
                              !_vm.location
                                ? _c(
                                    "div",
                                    { staticClass: "order-box__locations" },
                                    [
                                      _c("Button", {
                                        staticClass:
                                          "order-box__locations-reset",
                                        attrs: {
                                          level: "tertiary",
                                          type: "button",
                                          text: _vm.$t("orderbox.changeType"),
                                          arrow: "",
                                          reverse: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onCancel.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.hasFeature(
                                        "FEATURE_ORDERBOX_GEOLOCATION"
                                      ) &&
                                      _vm.form.selectedRegionCode ==
                                        "geolocation"
                                        ? _c("h3", {
                                            staticClass:
                                              "order-box__locations-title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "orderbox.locations.takeawayGeoTitle"
                                                )
                                              )
                                            }
                                          })
                                        : _c("h3", {
                                            staticClass:
                                              "order-box__locations-title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "orderbox.locations.takeawayTitle",
                                                  {
                                                    region: _vm.$t(
                                                      "orderbox.regions." +
                                                        _vm.formatRegionCode(
                                                          _vm.form
                                                            .selectedRegionCode
                                                        )
                                                    )
                                                  }
                                                )
                                              )
                                            }
                                          }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.takeawayRegionLocations,
                                        function(location) {
                                          return _c("OrderBoxLocation", {
                                            key: location.code,
                                            attrs: {
                                              location: _vm.formatLocation(
                                                location,
                                                _vm.selectedShippingMethod,
                                                _vm.form.selectedRegionCode
                                              ),
                                              "shipping-method":
                                                _vm.selectedShippingMethod
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onTakeawayLocationSelect(
                                                  $event,
                                                  location.code
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.selectedShippingMethod && _vm.location
                                ? [
                                    _vm.takeawayRegionLocations.length > 1 ||
                                    _vm.deliveryLocationMatches.length > 1
                                      ? _c("Button", {
                                          staticClass:
                                            "order-box__locations-reset",
                                          attrs: {
                                            level: "tertiary",
                                            type: "button",
                                            text: _vm.$t(
                                              "orderbox.locations.resetLocation"
                                            ),
                                            arrow: "",
                                            reverse: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.onResetLocation.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("OrderBoxLocation", {
                                      attrs: {
                                        location: _vm.formatLocation(
                                          _vm.location,
                                          _vm.selectedShippingMethod,
                                          _vm.form.selectedRegionCode,
                                          _vm.form.zip
                                        ),
                                        "shipping-method":
                                          _vm.selectedShippingMethod,
                                        "no-click": ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.locationClosedToday &&
                                    _vm.showClosedMessage
                                      ? [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "order-box__closed"
                                            },
                                            [
                                              _c("h2", {
                                                staticClass:
                                                  "order-box__closed-title",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "orderbox.closedToday.title"
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _c("div", {
                                                staticClass:
                                                  "order-box__closed-text",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "orderbox.closedToday.text",
                                                      {
                                                        location:
                                                          _vm.location.name
                                                      }
                                                    )
                                                  )
                                                }
                                              }),
                                              _vm._v(" "),
                                              _vm.locationClosedTodayCoupon
                                                ? _c("div", {
                                                    staticClass:
                                                      "order-box__closed-text",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "orderbox.closedToday.couponText",
                                                          {
                                                            amount: _vm.formatDiscount(
                                                              _vm
                                                                .locationClosedTodayCoupon
                                                                .discount
                                                            )
                                                          }
                                                        )
                                                      )
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.locationClosedTodayCoupon
                                                ? _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "order-box__closed-coupon"
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "order-box__closed-coupon-code"
                                                        },
                                                        [
                                                          _c("div", {
                                                            staticClass:
                                                              "order-box__closed-coupon-label",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "orderbox.closedToday.couponLabel"
                                                                )
                                                              )
                                                            }
                                                          }),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "order-box__closed-coupon-value",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm
                                                                  .locationClosedTodayCoupon
                                                                  .code
                                                              )
                                                            }
                                                          })
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c("Button", {
                                                        staticClass:
                                                          "order-box__closed-coupon-button",
                                                        attrs: {
                                                          level: "primary",
                                                          type: "button",
                                                          text:
                                                            _vm.copyCouponText ||
                                                            _vm.$t(
                                                              "orderbox.closedToday.couponCopy"
                                                            ),
                                                          icon: "duplicate",
                                                          small: ""
                                                        },
                                                        on: {
                                                          click: function(
                                                            $event
                                                          ) {
                                                            $event.preventDefault()
                                                            return _vm.onCopyToClipboard(
                                                              _vm
                                                                .locationClosedTodayCoupon
                                                                .code
                                                            )
                                                          }
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c("Button", {
                                            attrs: {
                                              level: "primary",
                                              type: "button",
                                              text: _vm.$t(
                                                "orderbox.closedToday.orderButton"
                                              ),
                                              block: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.onContinueClosed.apply(
                                                  null,
                                                  arguments
                                                )
                                              }
                                            }
                                          })
                                        ]
                                      : [
                                          _vm.errors.time
                                            ? _c("GeneralMessage", {
                                                attrs: {
                                                  message: _vm.errors.time,
                                                  type: "error"
                                                },
                                                on: {
                                                  close: function($event) {
                                                    _vm.errors.time = ""
                                                  }
                                                }
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          !_vm.errors.zip &&
                                          !_vm.errors.location &&
                                          !_vm.isLocationExternal
                                            ? [
                                                _c("OrderBoxTime", {
                                                  attrs: {
                                                    "uber-direct":
                                                      _vm.locationOrderUberDirect,
                                                    "order-now":
                                                      _vm.locationOrderNow,
                                                    "order-now-available":
                                                      _vm.locationOrderNowAvailable,
                                                    date: _vm.selectedDate,
                                                    dateMin: _vm.locationOrderMinDate.format(
                                                      "L"
                                                    ),
                                                    dateMax: _vm.locationOrderMaxDate.format(
                                                      "L"
                                                    ),
                                                    isDateDisabled: _vm.isDateDisabled.bind(
                                                      this
                                                    ),
                                                    time: _vm.selectedTime,
                                                    times:
                                                      _vm.locationOrderTimes,
                                                    buttonText:
                                                      _vm.orderButtonText,
                                                    "yielding-messages":
                                                      _vm.yieldingMessages
                                                  },
                                                  on: {
                                                    ordernowchanged:
                                                      _vm.onLocationOrderNowChange,
                                                    datechanged:
                                                      _vm.onLocationDateSelect,
                                                    timechanged:
                                                      _vm.onLocationTimeSelect,
                                                    click: _vm.onOrder
                                                  }
                                                }),
                                                _vm._v(" "),
                                                _vm.hasFeature(
                                                  "FEATURE_GROUP_ORDERS"
                                                ) && _vm.locationHasGroupOrder
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "order-box__icon-button"
                                                      },
                                                      [
                                                        _c("SVGUsers", {
                                                          staticClass:
                                                            "order-box__icon-button-icon"
                                                        }),
                                                        _vm._v(" "),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "order-box__icon-button-content"
                                                          },
                                                          [
                                                            _c("Button", {
                                                              staticClass:
                                                                "order-box__icon-button-button",
                                                              attrs: {
                                                                text: _vm.$t(
                                                                  "orderbox.groupOrder.button"
                                                                ),
                                                                type: "button",
                                                                level:
                                                                  "tertiary",
                                                                arrow: "",
                                                                disabled:
                                                                  !_vm
                                                                    .locationOrderTimes
                                                                    .length &&
                                                                  (!_vm.locationOrderNow ||
                                                                    !_vm.locationOrderNowAvailable)
                                                              },
                                                              on: {
                                                                click:
                                                                  _vm.onGroupOrderOpen
                                                              }
                                                            }),
                                                            _vm._v(" "),
                                                            _vm.$te(
                                                              "orderbox.groupOrder.hint"
                                                            )
                                                              ? _c("div", {
                                                                  staticClass:
                                                                    "order-box__icon-button-hint",
                                                                  domProps: {
                                                                    innerHTML: _vm._s(
                                                                      _vm.$t(
                                                                        "orderbox.groupOrder.hint"
                                                                      )
                                                                    )
                                                                  }
                                                                })
                                                              : _vm._e()
                                                          ],
                                                          1
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e()
                                              ]
                                            : _vm.isLocationExternal
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "order-box__external"
                                                },
                                                [
                                                  _c("h4", {
                                                    staticClass:
                                                      "order-box__external-title",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.location.name
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("p", {
                                                    staticClass:
                                                      "order-box__external-text",
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "orderbox.externalCourierText"
                                                        )
                                                      )
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _vm.locationExternalUrl
                                                    ? _c("Button", {
                                                        staticClass:
                                                          "order-box__external-button",
                                                        attrs: {
                                                          href:
                                                            _vm.locationExternalUrl,
                                                          target: "_blank",
                                                          level: "secondary",
                                                          type: "button",
                                                          text: _vm.$t(
                                                            "orderbox.externalCourierButton"
                                                          ),
                                                          arrow: ""
                                                        }
                                                      })
                                                    : _vm._e()
                                                ],
                                                1
                                              )
                                            : _vm._e()
                                        ],
                                    _vm._v(" "),
                                    _c("Button", {
                                      staticClass: "order-box__time-reset",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t("orderbox.changeType"),
                                        arrow: "",
                                        reverse: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.onCancel.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  ]
                                : _vm.selectedShippingMethod &&
                                  !_vm.location &&
                                  _vm.errors.zip
                                ? [
                                    _c("Button", {
                                      staticClass: "order-box__time-reset",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t("orderbox.changeType"),
                                        arrow: "",
                                        reverse: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.onCancel.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ]
                          : _vm._e()
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _vm.hasFeature("FEATURE_RESERVATION") &&
                    (_vm.locationsLoading || _vm.reservationLocations.length)
                      ? [
                          _c(
                            "div",
                            {
                              staticClass:
                                "order-box__content-wrapper order-box__content-wrapper--reservation",
                              class: {
                                "order-box__content-wrapper--loading":
                                  _vm.loading
                              }
                            },
                            [
                              _c("h3", {
                                staticClass: "order-box__subtitle",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("orderbox.reservationTitle")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "order-box__input-group" },
                                [
                                  _vm.reservationRegions.length > 1
                                    ? _c("FormInputSelect", {
                                        ref: "locationSelect",
                                        staticClass: "order-box__input-element",
                                        attrs: {
                                          options: _vm.reservationRegionOptions,
                                          label: _vm.$t(
                                            "orderbox.reservationRegionLabel"
                                          ),
                                          disabled:
                                            _vm.loading ||
                                            _vm.isLoading ||
                                            _vm.locationsLoading
                                        },
                                        on: {
                                          input: _vm.onReservationRegionSelect
                                        },
                                        model: {
                                          value:
                                            _vm.reservationForm
                                              .selectedRegionCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.reservationForm,
                                              "selectedRegionCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "reservationForm.selectedRegionCode"
                                        }
                                      })
                                    : _c("FormInputSelect", {
                                        ref: "locationSelect",
                                        staticClass: "order-box__input-element",
                                        attrs: {
                                          options:
                                            _vm.reservationLocationOptions,
                                          label: _vm.$t(
                                            "orderbox.reservationLabel"
                                          ),
                                          disabled:
                                            _vm.loading ||
                                            _vm.isLoading ||
                                            _vm.locationsLoading
                                        },
                                        on: {
                                          input: _vm.onReservationLocationSelect
                                        },
                                        model: {
                                          value:
                                            _vm.reservationForm
                                              .selectedLocationCode,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.reservationForm,
                                              "selectedLocationCode",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "reservationForm.selectedLocationCode"
                                        }
                                      }),
                                  _vm._v(" "),
                                  !_vm.reservationForm.selectedRegionCode &&
                                  !_vm.reservationForm.selectedLocationCode
                                    ? _c("Button", {
                                        staticClass: "order-box__input-button",
                                        attrs: {
                                          level: "primary",
                                          type: "button",
                                          text: _vm.$t(
                                            "orderbox.reservationButton"
                                          ),
                                          disabled:
                                            _vm.loading ||
                                            _vm.isLoading ||
                                            _vm.locationsLoading
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onReservation.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.errors.reservation
                                ? _c("span", {
                                    staticClass:
                                      "order-box__input-error input-error",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.errors.reservation)
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.reservationRegionLocations.length > 1 &&
                              _vm.reservationForm.selectedRegionCode &&
                              !_vm.reservationForm.selectedLocationCode
                                ? _c(
                                    "div",
                                    { staticClass: "order-box__locations" },
                                    [
                                      _c("Button", {
                                        staticClass:
                                          "order-box__locations-reset",
                                        attrs: {
                                          level: "tertiary",
                                          type: "button",
                                          text: _vm.$t(
                                            "orderbox.cancelReservation"
                                          ),
                                          arrow: "",
                                          reverse: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.onReservationCancel.apply(
                                              null,
                                              arguments
                                            )
                                          }
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.hasFeature(
                                        "FEATURE_ORDERBOX_GEOLOCATION"
                                      ) &&
                                      _vm.reservationForm.selectedRegionCode ==
                                        "geolocation"
                                        ? _c("h3", {
                                            staticClass:
                                              "order-box__locations-title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "orderbox.locations.takeawayGeoTitle"
                                                )
                                              )
                                            }
                                          })
                                        : _c("h3", {
                                            staticClass:
                                              "order-box__locations-title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "orderbox.locations.takeawayTitle",
                                                  {
                                                    region: _vm.$t(
                                                      "orderbox.regions." +
                                                        _vm.formatRegionCode(
                                                          _vm.reservationForm
                                                            .selectedRegionCode
                                                        )
                                                    )
                                                  }
                                                )
                                              )
                                            }
                                          }),
                                      _vm._v(" "),
                                      _vm._l(
                                        _vm.reservationRegionLocations,
                                        function(location) {
                                          return _c("OrderBoxLocation", {
                                            key: location.code,
                                            attrs: {
                                              location: _vm.formatLocation(
                                                location,
                                                "takeaway",
                                                _vm.reservationForm
                                                  .selectedRegionCode
                                              ),
                                              "shipping-method": "takeaway"
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.onReservationLocationSelect(
                                                  $event,
                                                  location.code
                                                )
                                              }
                                            }
                                          })
                                        }
                                      )
                                    ],
                                    2
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.reservationForm.selectedLocationCode
                                ? [
                                    _vm.reservationRegionLocations.length > 1
                                      ? _c("Button", {
                                          staticClass:
                                            "order-box__locations-reset",
                                          attrs: {
                                            level: "tertiary",
                                            type: "button",
                                            text: _vm.$t(
                                              "orderbox.locations.resetLocation"
                                            ),
                                            arrow: "",
                                            reverse: ""
                                          },
                                          on: {
                                            click: function($event) {
                                              $event.preventDefault()
                                              return _vm.onResetReservationLocation.apply(
                                                null,
                                                arguments
                                              )
                                            }
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c("OrderBoxLocation", {
                                      attrs: {
                                        location: _vm.formatLocation(
                                          _vm.reservationLocation,
                                          "takeaway",
                                          _vm.reservationForm.selectedRegionCode
                                        ),
                                        "shipping-method": "takeaway",
                                        "no-click": ""
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "order-box__time" },
                                      [
                                        _c(
                                          "keep-alive",
                                          [
                                            _c("Button", {
                                              staticClass:
                                                "order-box__time-button",
                                              attrs: {
                                                level: "primary",
                                                type: "button",
                                                text: _vm.$t(
                                                  "orderbox.reservationButton"
                                                )
                                              },
                                              on: {
                                                click: function($event) {
                                                  $event.preventDefault()
                                                  return _vm.onReservationSubmit.apply(
                                                    null,
                                                    arguments
                                                  )
                                                }
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("Button", {
                                      staticClass: "order-box__time-reset",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "orderbox.cancelReservation"
                                        ),
                                        arrow: "",
                                        reverse: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.onReservationCancel.apply(
                                            null,
                                            arguments
                                          )
                                        }
                                      }
                                    })
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ]
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.orderBoxLink
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "order-box__content-wrapper order-box__content-wrapper--links",
                            class: {
                              "order-box__content-wrapper--loading": _vm.loading
                            }
                          },
                          [
                            _vm.orderBoxLink.title
                              ? _c("h3", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.orderBoxLink.title,
                                      expression: "orderBoxLink.title"
                                    }
                                  ],
                                  staticClass: "order-box__subtitle"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.orderBoxLink.description
                              ? _c("div", {
                                  directives: [
                                    {
                                      name: "sanitize",
                                      rawName: "v-sanitize",
                                      value: _vm.orderBoxLink.description,
                                      expression: "orderBoxLink.description"
                                    }
                                  ],
                                  staticClass: "order-box__text"
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c("Button", {
                              attrs: {
                                text: _vm.orderBoxLink.text,
                                type: "button",
                                level: "tertiary",
                                arrow: "",
                                href: _vm.orderBoxLink.url,
                                target: _vm.orderBoxLink.target
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  2
                )
              ]
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm.hasFeature("FEATURE_GROUP_ORDERS")
        ? _c("Modal", {
            ref: "groupOrderModal",
            attrs: {
              "overlay-type": "group-order",
              "html-classes": ["hide--header", "show--modal"],
              narrow: ""
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function(ref) {
                    var closeModal = ref.closeModal
                    return [
                      _c("OverlayGroupOrderForm", {
                        attrs: {
                          title: _vm.$t("orderbox.groupOrder.title"),
                          "button-text": _vm.groupOrderButtonText,
                          loading:
                            _vm.loading || _vm.isLoading || _vm.locationsLoading
                        },
                        on: {
                          "cancel:grouporder": closeModal,
                          "submit:grouporder": _vm.onGroupOrderSubmit
                        }
                      })
                    ]
                  }
                }
              ],
              null,
              false,
              2318229152
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }